export const EN_US_PHONEME_ORDER = [
  // Stops / Affricates
  'p', 'pʰ', 'b', 't', 'd', 'k', 'kʰ', 'ɡ', 'tʃ', 'dʒ',
  // Fricatives
  'f', 'v', 'θ', 'θʰ', 'ð', 's', 'sʰ', 'z', 'ʃ', 'ʒ', 'h', 'ɦ', 'x', 'ɣ', 'β',
  // Nasals / Liquids / Approximants
  'm', 'm̩', 'n', 'n̩', 'ŋ', 'ŋ̍', 'l', 'l̩', 'r', 'ɹ', 'ɾ', 'ɾ̃', 'w', 'j',
  // Glottal
  'ʔ',
  // Monophthongs
  'i', 'ĩ', 'ɪ', 'e', 'ɛ', 'ɛ̃', 'æ', 'æ̃', 'a', 'ɑ', 'ɑ̃', 'ɒ', 'ɔ', 'ʊ', 'u', 'ʌ', 'ə', 'ə̥', 'ə̃', 'ɚ', 'ɜ', 'ɝ', 'ɨ', 'ʉ', 'o',
  // Diphthongs
  'eɪ', 'aɪ', 'aɪ̃', 'aʊ', 'ɔɪ', 'oʊ', 'oʊ̃', 'əʊ', 'ʊ̃',
];

